import { AbstractComponent } from "appworks/components/abstract-component";
import { graphicsManager } from "appworks/graphics/graphics-manager";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Contract } from "appworks/utils/contracts/contract";
import { Easing, Tween } from "appworks/utils/tween";
import { gameLayers } from "game-layers";
import { Graphics } from "pixi.js";

export class TGRFreespinIntroComponent extends AbstractComponent {

    protected highlights: Sprite[];
    protected highlightTween: Tween;
    protected reelDarken: Graphics;
    protected highlightTweenObj: { alpha: number} = { alpha: 0 };

    public init(): void {
        this.highlights = [];

        const darkPos: DualPosition = gameLayers.FreespinsIntro.getPosition("reel_darken");

        this.reelDarken = new Graphics();
        this.reelDarken.beginFill(0, 0.5);
        this.reelDarken.drawRect(darkPos.landscape.x, darkPos.landscape.y, darkPos.landscape.width, darkPos.landscape.height);
        this.reelDarken.endFill();
        this.reelDarken.alpha = 0;
        gameLayers.FreespinsIntro.add(this.reelDarken, false, true);

        for (let i: number = 0; i < 5; i++) {
            const sprite: Sprite = gameLayers.FreespinsIntro.getSprite(`highlight_${i}`);
            sprite.visible = false;
            this.highlights.push(sprite);
        }
    }

    public enableReelHighlights(): Contract<void> {
        return Contract.wrap(() => {
            this.highlightTweenObj = { alpha: 0 };
            this.highlightTween = new Tween(this.highlightTweenObj)
            .to({ alpha: 1}, 500)
            .repeat(Infinity)
            .yoyo(true)
            .onUpdate(() => this.updateHighlights())
            .onComplete(() => this.updateHighlights())
            .start();
        });
    }

    public disableReelHighlights(): Contract<void> {
        return Contract.wrap(() => {
            this.highlightTween.stop();
            new Tween(this.highlightTweenObj)
            .to({ alpha: 0}, 500)
            .onUpdate(() => this.updateHighlights())
            .onComplete(() => this.updateHighlights())
            .start();
        });
    }

    public animateSymbolsSprites(): Contract<void> {
        return new Contract<void>((resolve: (value?: any) => void) => {
            [2, 3, 2, 2, 3].forEach((syms: number, reel: number) => {
                for (let i: number = 0; i < syms; i++) {
                    const startPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`start_${reel}_${i}`);
                    const pauseStartPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`pause_start_${reel}_${i}`);
                    const pauseEndPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`pause_end_${reel}_${i}`);
                    const endPos: DualPosition = gameLayers.FreespinsIntro.getPosition(`end_${reel}_${i}`);

                    const assetName: string = reel === 4 ? "C" : "QH_intro";
                    const symSprite: Sprite = this.makeSymbolSprite(assetName, startPos);

                    const endTween = new Tween(symSprite.landscape);
                    endTween.to({y: endPos.landscape.y}, 500);
                    endTween.easing(Easing.Quadratic.In);
                    endTween.onComplete(() => {
                        gameLayers.FreespinsIntro.remove(symSprite);
                        if (reel === 4 && i === 2) {
                            resolve();
                        }
                    });

                    const pauseTween = new Tween(symSprite.landscape);
                    pauseTween.to({y: pauseEndPos.landscape.y}, 1500);
                    pauseTween.chain(endTween);

                    const startTween = new Tween(symSprite.landscape);
                    startTween.delay(60 * reel);
                    startTween.to({y: pauseStartPos.landscape.y}, 500);
                    startTween.chain(pauseTween);
                    startTween.start();
                }
            });
        });
    }

    protected updateHighlights(): void {
        this.reelDarken.alpha = this.highlightTweenObj.alpha > 0 ? 1 : 0;
        this.highlights.forEach((highlight: Sprite) => {
            highlight.alpha = this.highlightTweenObj.alpha;
            highlight.visible = this.highlightTweenObj.alpha !== 0;
        });
    }

    protected makeSymbolSprite(assetName: string, startPos: DualPosition): Sprite {
        const sprite: Sprite = graphicsManager.createSprite(assetName);
        sprite.landscape.set(startPos.landscape.x, startPos.landscape.y);
        sprite.landscape.width = startPos.landscape.width;
        sprite.landscape.height = startPos.landscape.height;
        gameLayers.FreespinsIntro.add(sprite);
        return sprite;
    }
}
